/**
 * ChiusoFields — campi per gli stage `chiuso` / `chiuso_cliente`:
 * selezione proposte chiuse + piano pagamenti + note contabili.
 * ★ Fase 59.P2 — estratto da StageTransitionModal.jsx. Comportamento invariato.
 */
import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import PaymentPlanEditor from '../PaymentPlanEditor';
import { ClosedProposalsSelector } from './ClosedProposalsSelector';
import i18n from '../../i18n';

export function ChiusoFields({
  form, set,
  sentProposals, loadingSent, closedPayments, setPay, availableUnits,
}) {
  return (
    <div className="space-y-4">
      <div className="rounded-md bg-green-50 border border-green-200 p-3 text-xs text-green-900">
        🏆 <b>Closed Won!</b> {i18n.t('stageTransition.closedIntro', 'Seleziona le proposte chiuse (Pagamenti) e imposta il piano pagamenti (rate).')}
      </div>
      <ClosedProposalsSelector
        sentProposals={sentProposals}
        loadingSent={loadingSent}
        closedPayments={closedPayments}
        setPay={setPay}
        availableUnits={availableUnits}
      />
      <div className="border-t pt-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">
          {i18n.t('stageTransition.paymentPlanTitle', 'Piano pagamenti (per contabilità mensile) *')}
        </div>
        <PaymentPlanEditor
          value={form.payment_plan}
          onChange={(plan) => set('payment_plan', plan)}
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wide">Note contabili (opzionale)</Label>
        <Textarea
          rows={2}
          value={form.contabile_note}
          onChange={(e) => set('contabile_note', e.target.value)}
          placeholder={i18n.t('stageTransition.accountingNotesPh', 'Note per la contabilità (es. metodo pagamento, IBAN…)')}
          data-testid="contabile-note-textarea"
          className="mt-1"
        />
      </div>
    </div>
  );
}
